"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PromoBannerText = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const PromoBannerText = (param)=>{
    let { title, promoBannerType, link } = param;
    const { getTestId } = (0, _testidGenerator.default)();
    const { title: linkTitle } = link !== null && link !== void 0 ? link : {};
    if (!title) {
        return null;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Inner, {
        promoBannerType: promoBannerType,
        "data-testid": getTestId(_constants.BANNER_TEXT),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Title, {
                component: "p",
                variant: "h6",
                promoBannerType: promoBannerType,
                children: title
            }),
            linkTitle ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.LinkImitation, {
                "data-testid": getTestId(_constants.BANNER_TEXT_LINK),
                className: _constants.BannerTextLinkClassName,
                promoBannerType: promoBannerType,
                children: linkTitle
            }) : null
        ]
    });
};
exports.PromoBannerText = PromoBannerText;
